import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'montoInteligente',
  standalone: true,
})
export class MontoInteligentePipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value == null || isNaN(Number(value))) {
      return '$0 CLP';
    }

    const monto = Number(value);

    
    if (monto >= 1_000_000) {
      const millones = monto / 1_000_000;
      return `$${millones.toLocaleString('es-CL', {
        maximumFractionDigits: 1,
        minimumFractionDigits: 0,
      })} M CLP`;
    }

    if (monto >= 1_000) {
      const miles = monto / 1_000;
      return `$${miles.toLocaleString('es-CL', {
        maximumFractionDigits: 1,
        minimumFractionDigits: 0,
      })} K CLP`;
    }

    return `$${monto.toLocaleString('es-CL')} CLP`;
  }
}